export default __webpack_public_path__ + "static/media/Archivo-Regular.a4455819.eot";